import "./libs/telegram-web-app.js";
import router from "@/router";

const WebApp = window.Telegram.WebApp;

export default {
  isApp: false,
  mainButtonCb: null,
  initDataUnsafe: null,
  initData: null,
  app: WebApp,
  init() {
    this.setTheme();
    if (WebApp && WebApp.platform !== "unknown") {
      this.isApp = true;
      this.getAppData();
      this.setBackButtonListener();
      WebApp.disableVerticalSwipes();
    } else {
      // this.setTestData();
    }
  },
  getAppData() {
    this.initDataUnsafe = WebApp.initDataUnsafe;
    this.initData = WebApp.initData;
  },
  // setTestData() {
  //   this.initData =
  //     "query_id=AAFh5eNSAAAAAGHl41LAds-I&user=%7B%22id%22%3A1390667105%2C%22first_name%22%3A%22Marat%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22MarkoTesla%22%2C%22language_code%22%3A%22ru%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2Fop1RHm-Pn6z8-b3coS0g5TaNOTj70l6yNjnlFrLnVro.svg%22%7D&auth_date=1749031629&signature=q5lgVdxBWjiK1THlLXjKVFw_iN_A3PIXZxRBXsMAwPFbMthqTSgjg8XiIuVZb5aS-SZIEW681CKL2SCuvr1QBg&hash=e8a94a1878a022d9e615755a8baae1e85e46f280f273c153405fdf03a2195475";
  //   this.initDataUnsafe = {
  //     user: {
  //       id: 113600249,
  //       first_name: "Aleksey",
  //       last_name: "Semenov",
  //       username: "maclonaky",
  //       language_code: "ru",
  //       allows_write_to_pm: true,
  //     },
  //     chat_instance: "944241444911726221",
  //     chat_type: "sender",
  //     auth_date: 1729674990,
  //     hash: "5ec19e76307dd4d8cfd597aafa9e337195d1f45bfa769cd4938a4d5c948eb371",
  //   };
  // },
  haptick(style) {
    WebApp.HapticFeedback.impactOccurred(style);
  },
  setTheme() {
    WebApp.setHeaderColor("#0A0A0A");
    WebApp.setBackgroundColor("#0A0A0A");
  },
  readTextFromClipboard: WebApp.readTextFromClipboard,
  expand() {
    WebApp.expand();
  },
  showBackButton() {
    WebApp.BackButton.show();
  },
  hideBackButton() {
    WebApp.BackButton.hide();
  },
  backButtonAction() {
    router.back();
  },
  setBackButtonListener() {
    WebApp.BackButton.onClick(this.backButtonAction);
  },
  removeBackButtonListener() {
    WebApp.BackButton.offClick(this.backButtonAction);
  },
  closeApp() {
    WebApp.close();
  },
};
